import React from 'react';
import { Icon } from '@polichat/flamboyant';
import {
  ProgressContainer,
  ProgressStep,
  ProgressLine,
  StepIcon,
  StepLabel
} from './ProgressBar.styles';

const ProgressBar = ({ currentStep, totalSteps = 3 }) => {
  const steps = [
    { number: 1, label: 'Conectar com Facebook', icon: 'poli-icon pi-facebook-fill' },
    { number: 2, label: 'Conectar WhatsApp', icon: 'poli-icon pi-whatsapp-fill' },
    { number: 3, label: 'Configurar Canal', icon: 'poli-icon pi-setting-fill' }
  ];

  return (
    <ProgressContainer>
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <ProgressStep>
            <StepIcon 
              isActive={currentStep >= step.number}
              isCompleted={currentStep > step.number}
            >
              {currentStep > step.number ? (
                <Icon icon="poli-icon pi-check-fill" size={20} color="white" />
              ) : (
                <Icon icon={step.icon} size={20} color={currentStep >= step.number ? "white" : "#ccc"} />
              )}
            </StepIcon>
            <StepLabel isActive={currentStep >= step.number}>
              {step.label}
            </StepLabel>
          </ProgressStep>
          {index < steps.length - 1 && (
            <ProgressLine isCompleted={currentStep > step.number} />
          )}
        </React.Fragment>
      ))}
    </ProgressContainer>
  );
};

export default ProgressBar;
